import httpClient from "../utils/httpClient";

export const GetParameters = async () => {
    const response = await httpClient.post('Parameter/get-parameters', {});
    return response.data;
};